import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { AuthGuard } from 'src/auth/guard';
import DashboardLayout from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const IndexPage = lazy(() => import('src/pages/dashboard/one'));


const Users = lazy(() => import('src/pages/dashboard/users'));
const UsersCreate = lazy(() => import('src/pages/dashboard/usersCreatePage'));
const Roles = lazy(() => import('src/pages/dashboard/roles'));
const RolesCreate = lazy(() => import('src/pages/dashboard/rolesCreatePage'));
const RelationRolService = lazy(() => import('src/pages/dashboard/RelationRolService'));

const Branches = lazy(() => import('src/pages/dashboard/branches'));
const BranchesCreate = lazy(() => import('src/pages/dashboard/branchesCreatePage'));

const Companies = lazy(() => import('src/pages/dashboard/companies'));
const CompaniesCreate = lazy(() => import('src/pages/dashboard/companiesCreatePage'));

const Products = lazy(() => import('src/pages/dashboard/products'));
const ProductsCreate = lazy(() => import('src/pages/dashboard/productsCreatePage'));

const Orders = lazy(() => import('src/pages/dashboard/orders'));

const OrdersHistory = lazy(() => import('src/pages/dashboard/ordersHistory'));

const Finance = lazy(() => import('src/pages/dashboard/finance'));


// Public
const UserAccountPage = lazy(() => import('src/pages/dashboard/account'));



// ----------------------------------------------------------------------

export const dashboardRoutes = [
  {
    path: 'dashboard',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <IndexPage />, index: true },
      {
        path: 'usuarios',
        children: [
          { element: <Users />, index: true,  },
          { path: 'new', element: <UsersCreate /> },
        ],
      },
      {
        path: 'sucursales',
        children: [
          { element: <Branches />, index: true,  },
          { path: 'new', element: <BranchesCreate /> },
        ],
      },
      {
        path: 'empresas',
        children: [
          { element: <Companies />, index: true,  },
          { path: 'new', element: <CompaniesCreate /> },
        ],
      },
      {
        path: 'roles',
        children: [
          { element: <Roles />, index: true },
          { path: 'new', element: <RolesCreate /> },
        ],
      },
      {
        path: 'ServiciosRol',
        children: [
          { element: <RelationRolService />, index: true },
        ],
      },
      {
        path: 'productos',
        children: [
          { element: <Products />, index: true,  },
          { path: 'new', element: <ProductsCreate /> },
        ],
      },
      {
        path: 'pedidos',
        children: [
          { element: <Orders />, index: true,  },
        ],
      },
      {
        path: 'historialPedidos',
        children: [
          { element: <OrdersHistory />, index: true,  },
        ],
      },
      {
        path: 'finanzas',
        children: [
          { element: <Finance />, index: true,  },
        ],
      },
      {
        path: 'publicas',
        children: [
          { element: <UserAccountPage />, index: true },
        ],
      },
    ],
    
  },
];
